import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sprout } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-[#fafaf9]" data-id="element-130">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="max-w-4xl mx-auto" data-id="element-132">
          <div className="text-center mb-16" data-id="element-133">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#4a7c2c]/10 rounded-full mb-6" data-id="element-134">
              <Sprout className="w-8 h-8 text-[#4a7c2c]" data-id="element-135" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-136">
              Por eso existe la Guía para Hacer Esquejes
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-137">
              Una guía clara y ordenada que te muestra qué hacer en cada etapa,
              sin dudas ni prueba y error.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-138">
            {/* Left Column */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#4a7c2c]" data-id="element-139">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-140">
                Vas a aprender el método paso a paso para:
              </h3>
              <ul className="space-y-4" data-id="element-141">
                {['Evitar errores comunes que matan las plantas', 'Entender el proceso completo de enraizamiento', 'Obtener resultados reales desde el primer intento'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-142">
                    <div className="mt-1 w-5 h-5 rounded-full bg-[#4a7c2c]/10 flex items-center justify-center flex-shrink-0" data-id="element-143">
                      <Check className="w-3 h-3 text-[#4a7c2c]" data-id="element-144" />
                    </div>
                    <span className="text-gray-700" data-id="element-145">{item}</span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Right Column */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-[#4a7c2c] p-8 rounded-2xl shadow-lg text-white" data-id="element-146">
              <h3 className="text-xl font-bold mb-6" data-id="element-147">
                Con esta guía vas a saber exactamente:
              </h3>
              <ul className="space-y-4" data-id="element-148">
                {['Dónde y cómo cortar correctamente', 'Qué sustrato usar en cada caso', 'Cuándo intervenir y cuándo esperar', 'Cómo acompañar el esqueje hasta que enraíza'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-149">
                    <div className="mt-1 w-5 h-5 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-150">
                      <Check className="w-3 h-3 text-white" data-id="element-151" />
                    </div>
                    <span className="text-gray-100" data-id="element-152">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>

          <div className="text-center mt-12" data-id="element-153">
            <p className="text-lg font-medium text-gray-700 bg-white inline-block px-6 py-3 rounded-full shadow-sm border border-gray-100" data-id="element-154">
              Todo explicado de forma simple, práctica y pensada para personas
              reales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}